import axios from 'axios';

const COMMENT = process.env.VUE_APP_COMMENT;

class CommentCalls {

  create(comment) {
    return axios.post(COMMENT + "create/", { comment })
    .then(response => response.data.comment);
  }

  get(chapterId, commentId) {
    return axios.get(COMMENT + `id/${chapterId}/${commentId}/`)
    .then(response => response.data.comment);
  }

  getByChapter(chapterId) {
    return axios.get(COMMENT + "id/" + chapterId)
    .then(response => response.data.comments);
  }

  getReplies(chapterId, commentId) {
    return axios.get(COMMENT + `id/${chapterId}/${commentId}/replies/`)
    .then(response => response.data.comments);
  }

  edit(chapterId, commentId, content) {
    return axios.put(COMMENT + `id/${chapterId}/${commentId}/edit`, { content })
    .then(response => response.data.comment);
  }

  remove(chapterId, commentId, author) {
    return axios.put(COMMENT + `id/${chapterId}/${commentId}/remove`, { author })
    .then(response => response.data.comment);
  }
}

const commentCalls = new CommentCalls();
export default commentCalls;
